import type { ThemeTypings } from "@chakra-ui/react";

const primitiveColors = {
  white: "#ffffff",
  black: "#18181C",

  whiteAlpha: {
    0: "#ffffff00",
    50: "#ffffff0a",
    100: "#ffffff0f",
    200: "#ffffff14",
    300: "#ffffff29",
    400: "#ffffff3d",
    500: "#ffffff5c",
    600: "#ffffff7a",
    700: "#ffffffa3",
    800: "#ffffffcc",
    900: "#ffffffeb",
    950: "#fffffff2",
  },

  blackAlpha: {
    0: "#18181C00",
    50: "#18181C0A",
    100: "#18181C0F",
    200: "#18181C14",
    300: "#18181C29",
    400: "#18181C3D",
    500: "#18181C5C",
    600: "#18181C7A",
    700: "#18181CA3",
    800: "#18181CCC",
    900: "#18181CEB",
    950: "#18181CF2",
  },

  gray: {
    50: "#F9F9FA",
    100: "#EEEEF1",
    200: "#DDDDE3",
    300: "#C8C8D1",
    400: "#A9A9BB",
    500: "#87879F",
    600: "#6B6B82",
    700: "#505064",
    800: "#3A3A4D",
    900: "#2A2A3D",
    950: "#202026",
  },

  sky: {
    50: "#E6F3FF",
    100: "#D0E8FF",
    200: "#B8DDFF",
    300: "#99CEFF",
    400: "#63B0F7",
    500: "#298DE9",
    600: "#0E71CC",
    700: "#0B5EAB",
    800: "#084073",
    900: "#1F374E",
    950: "#04182B",
  },

  aqua: {
    50: "#ECFDFE",
    100: "#D4FAFC",
    200: "#A4F4F9",
    300: "#70EFF5",
    400: "#10D6E0",
    500: "#0EBAC3",
    600: "#0C9AA2",
    700: "#087277",
    800: "#05494C",
    900: "#122E2F",
    950: "#0B191A",
  },

  green: {
    50: "#F0FCF9",
    100: "#E3F7F2",
    200: "#B8E5DA",
    300: "#80DBC5",
    400: "#44BD9F",
    500: "#00B287",
    600: "#008F6B",
    700: "#00644B",
    800: "#044333",
    900: "#18302A",
    950: "#011B15",
  },

  electricYellow: {
    50: "#FBFCEE",
    100: "#F4F7C9",
    200: "#F0F5B2",
    300: "#F1F98B",
    400: "#F0FB6A",
    500: "#EFFF33",
    600: "#D8E90C",
    700: "#929E0A",
    800: "#4A4F17",
    900: "#18302A",
    950: "#1A1C02",
  },

  sand: {
    50: "#FEFAF3",
    100: "#FFF1DA",
    200: "#FFE2B0",
    300: "#F5CA7F",
    400: "#F2B347",
    500: "#F2A521",
    600: "#DE8D00",
    700: "#85590D",
    800: "#513C17",
    900: "#41331A",
    950: "#281C07",
  },

  red: {
    50: "#FFF4F1",
    100: "#FFEAE4",
    200: "#FFD9CE",
    300: "#FFBEAB",
    400: "#FF8965",
    500: "#FF5B29",
    600: "#E94716",
    700: "#A33B1B",
    800: "#733522",
    900: "#4B291E",
    950: "#2A0F07",
  },

  pink: {
    50: "#FFF5FB",
    100: "#FDE9F5",
    200: "#FED2EC",
    300: "#FCB3DF",
    400: "#F883C9",
    500: "#FA53B7",
    600: "#D7479D",
    700: "#B24D8A",
    800: "#6C234F",
    900: "#481935",
    950: "#280E1E",
  },

  purple: {
    50: "#F9F5FF",
    100: "#EDE2FF",
    200: "#DCC6FF",
    300: "#CBAAFF",
    400: "#B98CFF",
    500: "#A871FF",
    600: "#8652D9",
    700: "#7042BB",
    800: "#4B2E7A",
    900: "#32214E",
    950: "#1C112D",
  },

  indigo: {
    50: "#F5F5FF",
    100: "#EDEEFF",
    200: "#CED0FF",
    300: "#B3B6FF",
    400: "#8F93F9",
    500: "#666BFF",
    600: "#484EFF",
    700: "#3D4270",
    800: "#2D3159",
    900: "#262B47",
    950: "#1A1926",
  },
};

export const colors = {
  ...primitiveColors,
};

export type ThemeColors = ThemeTypings["colors"];
